import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=5cb0f6e1&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=5cb0f6e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0f6e1",
  null
  
)

export default component.exports